module.exports = __webpack_public_path__ + "stellar-xlm-logo.svg?ad29091e7d23481da4685f74853b6ee5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/stellar-xlm-logo.svg
// module id = 459
// module chunks = 2